import React, { useEffect, useState } from "react";
import { MessageCircle, Phone, Send } from "lucide-react";
import { WHATSAPP_NUMBER, PHONE_DISPLAY, PHONE_TEL } from "./Siteconfig";
import { publicApi } from "../admin/adminApi";
import useScrollReveal from "../hooks/useScrollReveal";
import "./Enquiry.css";
export default function Enquiry() {
  const revealRef = useScrollReveal();
  const [name, setName] = useState("");
  const [courses, setCourses] = useState([]);
  const [course, setCourse] = useState("");
  useEffect(() => {
    let cancelled = false;
    publicApi
      .listCourses()
      .then((data) => {
        if (!cancelled) {
          setCourses(data);
          if (data.length > 0) setCourse(data[0].name);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  const openWhatsApp = (e) => {
    e.preventDefault();
    const who = name.trim() ? name.trim() : "there";
    const chosenCourse = course || "a course";
    const message = `Hi What Next! This is ${who}. I'd like to join the ${chosenCourse} batch — please share the timings and fees.`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, "_blank");
  };
  return (
    <section className="enquiry" id="enquire" ref={revealRef}>
      <div className="container enquiry__inner">
        <div className="enquiry__copy reveal">
          <span className="eyebrow" style={{ color: "var(--c-white)" }}>
            Talk to a Mentor
          </span>
          <h2>Talk to a Mentor. Find the Right Course for Your Career.</h2>
          <p>
            Not sure which course matches your goals? Share your interests and
            we'll help you choose the right learning path based on your
            background, career aspirations, and current skill level. Our team
            will guide you through course details, upcoming batches, fees, and
            enrollment.
          </p>
          <div className="enquiry__direct">
            <a className="enquiry__direct-item" href={`tel:${PHONE_TEL}`}>
              <span className="enquiry__direct-icon">
                <Phone size={18} />
              </span>
              <div>
                <strong>Call Now</strong>
                <span>{PHONE_DISPLAY}</span>
              </div>
            </a>
            <a
              className="enquiry__direct-item"
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              rel="noreferrer"
            >
              <span className="enquiry__direct-icon">
                <MessageCircle size={18} />
              </span>
              <div>
                <strong>Chat on WhatsApp</strong>
                <span>Usually replies in minutes</span>
              </div>
            </a>
          </div>
        </div>
        <form className="enquiry__card reveal reveal-delay-2" onSubmit={openWhatsApp}>
          <label className="enquiry__field">
            <span>Your name</span>
            <input
              type="text"
              placeholder="e.g. Aditi Sharma"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </label>
          <label className="enquiry__field">
            <span>Course you're interested in</span>
            <select value={course} onChange={(e) => setCourse(e.target.value)}>
              {courses.map((c) => (
                <option key={c._id || c.slug} value={c.name}>
                  {c.name}
                </option>
              ))}
            </select>
          </label>
          <button type="submit" className="btn btn-primary enquiry__submit">
            <Send size={17} /> Send on WhatsApp
          </button>
          <p className="enquiry__note">
            Opens WhatsApp with your message pre-filled — nothing is sent from
            here directly.
          </p>
        </form>
      </div>
    </section>
  );
}